export default __webpack_public_path__ + "static/media/9_16-clip-ad-combined.9b75fd98.png";